import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

const styles = {
  leftIcon: {
    padding: '0px'
  }
};

const enhance = compose(withState('openDelete', 'updateOpenDelete', false));

const button = enhance(({ hrefLink }) => {
  return (
    <div>
      <Link href={hrefLink} target="_blank" style={{ color: '#2196f3' }}>
        ごちリンク
      </Link>
    </div>
  );
});

export default withStyles(styles)(button);
